import React, { useEffect, useState } from 'react'
import Swal from 'sweetalert2';
import { myApi } from '../../../config/axiosConfig';
import { PDFDownloadLink } from '@react-pdf/renderer';
import { Typography, Grid2, Button, Box } from '@mui/material';

// ICONOS
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import QrCodeIcon from '@mui/icons-material/QrCode';
import SyncIcon from '@mui/icons-material/Sync';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import CancelIcon from '@mui/icons-material/Cancel';

// COMPONENTES
import Qrdoc from './pdf/QrDoc';
import MiTabla from '../../../components/plantilla/tabla/MiTabla';
import EditarTractor from './modales/EditarTractor';

const Tractores = () => {

    // ===========================================
    // FUNCION PARA BUSCAR TRACTORES
    // ===========================================

    const [tractores, setTractores] = useState([]);

    const buscarTractores = async () => {

        try {

            const response = await myApi.get('/tractores/catalogo');

            setTractores(response.data.data);

        } catch(error) {

            console.log(error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Hubo un error al buscar los tractores.'
            });

        }

    }

    // ===========================================
    // FUNCION PARA ACTUALIZAR DATOS DE TRACTORES
    // ===========================================

    const handleUpdateTractores = async () => {

        Swal.fire({
            title: 'Sincronizando Datos...',
            text: 'Por favor, espera...',
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });
    
        try {

            const response = await myApi.get('tractores/actualizar_tractores');

            if(response.data.success){

                buscarTractores();

                // Cuando finaliza, mostrar un mensaje de éxito
                Swal.fire({
                    icon: 'success',
                    title: '¡Datos Sincronizados!',
                    timer: 2000,
                    showConfirmButton: false
                });

            }
    
        } catch (error) {

            // Si ocurre un error, mostrar un mensaje de error
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Hubo un problema al liberar las licencias.',
            });

        }

    }

    // ===========================================
    // COLUMNAS PARA TABLA
    // ===========================================

    const columns = [

        {
            field: 'tractor', 
            headerName: 'Tractor',
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        {
            field: 'mcleod_fleet', 
            headerName: 'Fleet',
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        { 
            field: 'model', 
            headerName: 'Modelo',
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        { 
            field: 'mcleod_type_of', 
            headerName: 'Tipo',
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        { 
            field: 'mcleod_placas', 
            headerName: 'Placas USA',
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        { 
            field: 'mcleod_placas_mx', 
            headerName: 'Placas MX',
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        { 
            field: 'mcleod_id', 
            headerName: 'Mcleod',
            flex: 1,
            headerAlign: "center",
            align: "center",
            renderCell: (params) => params.row.mcleod_id !== '--'? <TaskAltIcon /> : <CancelIcon />,
        },
        { 
            field: 'intangles_company_id', 
            headerName: 'Intangles',
            flex: 1,
            headerAlign: "center",
            align: "center",
            renderCell: (params) => params.row.intangles_company_id !== '--'? <TaskAltIcon /> : <CancelIcon />,
        },
        { 
            field: 'samsara_truck_id', 
            headerName: 'Samsara',
            flex: 1,
            headerAlign: "center",
            align: "center",
            renderCell: (params) => params.row.samsara_truck_id !== '--'? <TaskAltIcon /> : <CancelIcon />,
        },

    ];

    // ===========================================
    // ESTADO PARA MODAL
    // ===========================================

    const [showModal, setShowModal] = useState(false);
    const [formValues, setFormValues] = useState({});

    const handleRowClick = (params) => {

        setFormValues(params.row)
        setShowModal(true)

    }

    // ===========================================
    // USE EFFECT PARA LLAMAR DATOS
    // ===========================================

    useEffect(() => {

        buscarTractores();

    }, []);

    // ===========================================

    return (

        <Grid2 container>

            {/* HEADER */}

            <Grid2 
                size={12}
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                }}
            >

                <Typography
                    variant="h4"
                    fontWeight={700}
                >
                    Catalogo Tractores
                </Typography>

                <Box>

                    {/* BOTON PARA ACTUALIZAR DATOS */}

                    <Button
                        variant="contained" 
                        color="secondary"
                        loadingPosition="start"
                        loading={false}
                        startIcon={<SyncIcon/>}
                        sx={{ marginRight: 2 }}
                        onClick={handleUpdateTractores}
                    >
                        Actualizar Datos
                    </Button>

                    {/* BOTON PARA DESCARGAR QR */}

                    {/* <PDFDownloadLink 
                        document={<Qrdoc tractores={tractores} />} 
                        fileName="QR_Tractores.pdf"
                    >
                        {({ loading }) => (
                            <Button 
                                variant="contained" 
                                color="primary" 
                                disabled={loading}
                                startIcon={loading ? <HourglassEmptyIcon /> : <QrCodeIcon />}
                            >
                                {loading ? "Generando PDF..." : "Descargar QR"}
                            </Button>
                        )}
                    </PDFDownloadLink> */}

                </Box>

            </Grid2>

            {/* TABLA */}

            <Grid2 size={12} marginTop={2}>

                <MiTabla
                    data={tractores}
                    columns={columns}
                    rowClick={handleRowClick}
                />

            </Grid2>

            {/* MODAL PARA EDITAR TRACTOR */}

            <EditarTractor 
                open={showModal}
                onClose={() => setShowModal(false)}
                refresh={buscarTractores}
                data={formValues}
            />

        </Grid2>

    )

}

export default Tractores